<template>
  <b-modal size="xl" v-model="showForm" :title="$t('title')" no-close-on-backdrop no-enforce-focus>
    <div class="row">
      <template v-if="!imageLoading">
        <div
            v-if="formModel.type === 'enterprise' && ['image/jpeg', 'image/jpg'].includes(formModel.businessRegistrationType)"
            class="col-md">
          <b-card
              :sub-title="$t('businessRegistration')"
              :img-src="formModel.businessRegistrationUrl || '/img/default-avatar.png'"
              body-class="pb-1"
              img-bottom
              tag="a"
              :href="formModel.businessRegistrationUrl"
              target="_blank"
          >
          </b-card>
        </div>
        <div class="col-md">
          <b-card
              :sub-title="$t('ownerPicture')"
              :img-src="formModel.ownerUrl || '/img/default-avatar.png'"
              body-class="pb-1"
              img-bottom
              tag="a"
              :href="formModel.ownerUrl"
              target="_blank"
          >
          </b-card>
        </div>
        <div class="col-md">
          <b-card
              :sub-title="$t('IDFront')"
              :img-src="formModel.IDFrontUrl || '/img/default-avatar.png'"
              body-class="pb-1"
              img-bottom
              tag="a"
              :href="formModel.IDFrontUrl"
              target="_blank"
          >
          </b-card>
        </div>
        <div class="col-md">
          <b-card
              :sub-title="$t('IDBack')"
              :img-src="formModel.IDBackUrl || '/img/default-avatar.png'"
              body-class="pb-1"
              img-bottom
              tag="a"
              :href="formModel.IDBackUrl"
              target="_blank"
          >
          </b-card>
        </div>
        <div v-if="formModel.type === 'personal'" class="col-md">
          <b-card
              :sub-title="$t('proofOfAddress')"
              :img-src="formModel.proofOfAddressUrl || '/img/default-avatar.png'"
              body-class="pb-1"
              img-bottom
              tag="a"
              :href="formModel.proofOfAddressUrl"
              target="_blank"
          >
          </b-card>
        </div>
        <div
            v-if="formModel.type === 'enterprise' && !['image/jpeg', 'image/jpg'].includes(formModel.businessRegistrationType)"
            class="col-md">
          <b-card
              :sub-title="$t('businessRegistration')"
              sub-title-text-variant="info"
              body-class="pb-1"
              tag="a"
              :href="formModel.businessRegistrationUrl"
              target="_blank"
          >
          </b-card>
        </div>
      </template>
      <div v-if="formModel.contract && formModel.sendContractTime" class="col-md">
        <b-card
            :sub-title="$t('contract')"
            sub-title-text-variant="info"
            body-class="pb-1"
            img-width="auto"
            tag="a"
            :href="formModel.contractUrl"
            target="_blank"
        >
        </b-card>
      </div>
    </div>

    <div class="row d-flex align-items-stretch">
      <div class="col-md">
        <fieldset class="scheduler-border tile h-100">
          <legend class="scheduler-border">
            {{ $t("kycInformation") }}
          </legend>
          <client-select :disabled="formModel._id ? true : false" :label="$t('client')" :model="formModel"
                         attribute="client" :errors="formErrors"></client-select>
          <form-select :label="$t('type')" :model="formModel" attribute="type" :full-width="true" :options="[
              {value: 'personal', text: $t('personal')},
              {value: 'enterprise', text: $t('enterprise')}
            ]">
          </form-select>
          <form-file v-if="formModel.type === 'enterprise'" :label="$t('businessRegistration')"
                     service="/upload/upload-kyc" :model="formModel" @change="getImageUrl('businessRegistration')"
                     attribute="businessRegistration" attribute-file-type="businessRegistrationType"
                     :errors="formErrors" accept="image/jpeg,image/jpg,application/pdf">
          </form-file>
          <form-file :label="$t('owner')" service="/upload/upload-kyc" :model="formModel" @change="getImageUrl('owner')"
                     attribute="owner" :errors="formErrors" accept="image/jpeg,image/jpg,application/pdf">
          </form-file>
          <form-file :label="$t('IDFront')" service="/upload/upload-kyc" :model="formModel"
                     @change="getImageUrl('IDFront')"
                     attribute="IDFront" :errors="formErrors" accept="image/jpeg,image/jpg,application/pdf">
          </form-file>
          <form-file :label="$t('IDBack')" service="/upload/upload-kyc" :model="formModel"
                     @change="getImageUrl('IDBack')"
                     attribute="IDBack" :errors="formErrors" accept="image/jpeg,image/jpg,application/pdf">
          </form-file>
          <form-file v-if="formModel.type === 'personal'" :label="$t('proofOfAddress')" service="/upload/upload-kyc"
                     :model="formModel" @change="getImageUrl('proofOfAddress')"
                     attribute="proofOfAddress" :errors="formErrors" accept="image/jpeg,image/jpg,application/pdf">
          </form-file>
        </fieldset>
      </div>
      <div class="col-md">
        <fieldset class="scheduler-border tile h-100">
          <legend class="scheduler-border">
            {{ $t("invoiceInformation") }}
          </legend>
          <form-checkbox :chk-label="$t('invoiceEnabled')" :model="formModel"
                         attribute="invoiceEnabled"></form-checkbox>
          <template v-if="formModel.type === 'enterprise'">
            <h6>{{ $t('companyInfo') }}</h6>
            <form-input :label="$t('companyName')" :model="formModel" attribute="companyName"
                        :errors="formErrors"></form-input>
            <form-input :label="$t('address')" :model="formModel" attribute="companyAddress"
                        :errors="formErrors"></form-input>
            <form-input :label="$t('taxCode')" :model="formModel" attribute="companyTaxCode"
                        :errors="formErrors"></form-input>
          </template>
          <h6 v-if="formModel.type === 'enterprise'">{{ $t('ownerInfo') }}</h6>
          <form-input :label="$t('fullName')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
          <form-input :label="$t('address')" :model="formModel" attribute="address" :errors="formErrors"></form-input>
          <form-input :label="$t('taxCode')" :model="formModel" attribute="taxCode" :errors="formErrors"></form-input>
          <form-array :label="$t('invoiceEmails')" :model="formModel" attribute="invoiceEmails"
                      :errors="formErrors"></form-array>
        </fieldset>
      </div>
    </div>
    <div class="row d-flex align-items-stretch">
      <div class="col-md">
        <fieldset class="scheduler-border tile h-100">
          <legend class="scheduler-border">
            {{ $t("callScript") }}
          </legend>

          <span v-if="formModel.callScript" v-html="formModel.callScript.replace(/\n/g, '<br/>')"
                class="h-word-break"></span>
          <span v-else>{{ $t('notUpdated') }}</span>
        </fieldset>
      </div>
      <div class="col-md">
        <fieldset class="scheduler-border tile h-100">
          <legend class="scheduler-border">
            {{ $t("status") }}
          </legend>

          <form-checkbox :chk-label="$t('offBuyNumber')" :model="formModel" attribute="offBuyNumber"
                         :errors="formErrors"/>

          <form-radio-group :model="formModel" attribute="status" :options="[
                {value: 'canceled', text: $t('canceled')},
                {value: 'confirmed', text: $t('confirmed')}
          ]"></form-radio-group>
          <form-textarea :label="$t('note')" row="4" attribute="note" :model="formModel" :errors="formErrors"
                         :placeholder="$t('notePlaceholder')"/>
        </fieldset>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button class="btn btn-secondary float-right" @click="showForm = false">
        {{ $t('cancel') }}
      </button>
      <button
          v-if="['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager'].includes($store.state.user.role)"
          class="btn btn-primary float-right" @click="process('confirm')">
        {{ $t('save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import CRUD from "@/mixins/CRUD";
import ClientSelect from "@/components/ClientSelect.vue";

export default {
  components: {ClientSelect},
  mixins: [CRUD],
  data: function () {
    return {
      service: '/client-kyc',
      reloadBus: 'reloadKYC',
      defaultFormModel: {
        type: 'enterprise',
        status: 'confirmed',
        invoiceEnabled: true,
        businessRegistrationType: 'image/jpeg',
        businessRegistration: null,
        IDFront: null,
        IDBack: null,
        owner: null,
        proofOfAddress: null,
        offBuyNumber: false
      },
      imageLoading: false
    }
  },
  watch: {
    "formModel": function (val) {
      if (val && val._id) {
        if (val.confirmTime) {
          this.formModel.status = 'confirmed'
        }
        if (val.cancelTime) {
          this.formModel.status = 'canceled';
        }
      }
    }
  },
  methods: {
    process() {
      this.$swal({
        title: this.$t('processConfirm'),
        icon: "question",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.save();
        }
      })
    },
    getImageUrl(prop) {
      if (this.formModel[prop]) {
        this.imageLoading = true;
        this.$service.get(this.service + '/images/' + this.formModel[prop])
            .then(response => {
              this.formModel[prop + 'Url'] = response.data;
            })
            .catch(() => {
              this.formModel[prop + 'Url'] = null;
            })
            .finally(() => {
              this.imageLoading = false;
            })
      } else {
        this.formModel[prop + 'Url'] = null;
      }
    },
  },
  i18n: {
    messages: {
      en: {
        updateSuccess: 'Update success',
        note: 'Note',
        notePlaceholder: 'Note or cancel reason',
        businessRegistration: "Business Registration",
        contract: "Contract",
        IDFront: "ID Front",
        IDBack: "ID Back",
        ownerPicture: "Owner Picture",
        customer: "Customer",
        personal: "Personal",
        enterprise: "Enterprise",
        proofOfAddress: "Proof of address",
        cancel: "Cancel",
        profile: "Profile",
        processConfirm: "Do you want to perform this action?",
        invoiceInformation: "invoice information",
        address: "Address",
        taxCode: "Tax code",
        invoiceEmails: "Email receipt invoice",
        kycInformation: "KYC information",
        canceled: "Canceled",
        confirmed: "Confirmed",
        invoiceEnabled: "Agree to receive invoices",
        companyInfo: "Company info",
        ownerInfo: "Owner info",
        fullName: "Full name",
        callScript: "Call script",
        offBuyNumber: "Disable the function of buying phone numbers automatically",
      },
      vi: {
        title: "Hồ sơ khách hàng",
        updateSuccess: 'Cập nhật thành công!',
        note: 'Ghi chú của người duyệt',
        notePlaceholder: 'Ghi chú hoặc lý do từ chối',
        businessRegistration: "Đăng ký kinh doanh",
        contract: "Hợp đồng",
        IDFront: "CCCD mặt trước",
        IDBack: "CCCD mặt sau",
        ownerPicture: "Ảnh người đại diện",
        customer: "Khách hàng",
        personal: "Cá nhân",
        enterprise: "Doanh nghiệp",
        proofOfAddress: "Xác minh địa chỉ",
        cancel: "Huỷ",
        processConfirm: "Bạn có chắc chắn muốn thực hiện hành động này?",
        invoiceInformation: "Thông tin xuất hoá đơn",
        address: "Địa chỉ",
        taxCode: "Mã số thuế",
        invoiceEmails: "Email nhận hoá đơn",
        kycInformation: "Thông tin KYC",
        canceled: "Từ chối",
        confirmed: "Xác nhận",
        invoiceEnabled: "Đồng ý nhận xuất hoá đơn",
        companyInfo: "Thông tin công ty",
        ownerInfo: "Thông tin người đại diện",
        fullName: "Họ và tên",
        callScript: "Kịch bản gọi",
        offBuyNumber: "Khoá chức năng tự mua số điện thoại",
      }
    }
  }
}
</script>

<style>
.h-word-break {
  word-break: break-word !important;
}
</style>